import React from "react";
import { useTranslations } from "next-intl";
import { LabeledInput } from "@/shared/ui/LabeledInput";
import { Checkbox } from "@/shared/ui/Checkbox";
import { Button } from "@/shared/ui/Button";
import { useEnterNavigation } from "@/shared/lib/hooks/useEnterNavigation";

const SignIn = ({
  emailStatus,
  emailMsg,
  email,
  setEmail,
  passwordStatus,
  passwordMsg,
  password,
  setPassword,
  passwordInputType,
  ShowPasswordButton,
  isPersistent,
  setIsPersistent,
  submit,
}) => {
  const t = useTranslations("Auth");
  const { getFieldProps } = useEnterNavigation({
    fields: [{ id: "email" }, { id: "password" }],
    onSubmit: submit,
  });

  return (
    <>
      <LabeledInput
        status={emailStatus}
        msg={emailMsg}
        value={email}
        onChangeValue={setEmail}
        label={t('이메일')}
        id={'email'}
        placeholder={t('이메일 주소를 입력해주세요')}
        containerClassName={'mb-[8px]'}
        {...getFieldProps('email')}
      />
      <LabeledInput
        status={passwordStatus}
        msg={passwordMsg}
        value={password}
        onChangeValue={setPassword}
        type={passwordInputType}
        label={t('비밀번호')}
        id={'password'}
        placeholder={t('비밀번호를 입력해 주세요')}
        containerClassName={''}
        button={ShowPasswordButton}
        englishOnly
        {...getFieldProps('password')}
      />
      <Checkbox
        className={'tablet:mt-[4px] base:mt-[20px]'}
        label={t('로그인 유지하기')}
        checked={isPersistent}
        setChecked={setIsPersistent}
        id={'is_persistent'}
      />
      <Button
        className={'main:mb-[32px] main:mt-[50px] mt-[22px] mb-[12px]'}
        onClick={submit}
      >
        {t('로그인')}
      </Button>
    </>
  );
};
export default SignIn;
